import styles from './index.module.scss';
import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/app/utils/useLang';
import Right from './Right';
import EcoImg from 'eco-design/base/eco-img';

const LastSwiperItem: React.FC = () => {
    const { locale } = getLocal();
    const { t } = useLang('theProduct.productlist');

    const handleLink = () => {
        window.open(`https://www.ecoflow.com/${locale}/stream-series-energy-saving-calculator`, '_blank');
    };

    const handleLinkAll = () => {
        window.open(`https://${locale}.ecoflow.com/pages/stream-series-plug-in-solar-battery`, '_blank');
    };
    return (
        <>
            <div className="top-box">
                <EcoImg
                    pc="https://websiteoss.ecoflow.com/upload/image/1749636444685/PC.jpg"
                    pad="https://websiteoss.ecoflow.com/upload/image/1749636444905/M.jpg"
                />
                <div className="text-box">
                    <div className="top-box-label">{t('productlist_other_best')}</div>
                    <div className="top-box-title">{t('productlist_choose')}</div>
                    <Right className="right-icon" onClick={() => handleLink()} />
                </div>
            </div>
            <div className="bottom-box">
                <div className="bottom-box-title">{t('productlist_viewall')}</div>
                <Right className="right-icon" onClick={() => handleLinkAll()} />
            </div>
        </>
    );
};

export default LastSwiperItem;
